import React, { FC } from 'react';
import Modal from '@common/modal';
import { JOBDA_SUPPORT_EMAIL } from '@domain/constant/contact';
import { V2Route } from '@utils/routeUtil';

import classnames from 'classnames/bind';
import styles from './unlinkableModal.module.scss';
const cx = classnames.bind(styles);

interface IUnLinkableModalProps {
  visible: boolean;
  onClose: () => void;
}

const UnLinkableModal: FC<IUnLinkableModalProps> = ({ visible, onClose }) => {
  const onClickBtn = () => {
    onClose();
    V2Route.goMainPage();
  };

  return (
    <Modal visible={visible}>
      <div className={cx('layer')}>
        <strong className={cx('title')}>연동할 수 없는 계정입니다.</strong>

        <ul className={cx('noticeList')}>
          <li className={cx('listItem')}>
            기업에서 작성한 전화번호와 회원님의 계정 전화번호가 다를 경우 연동이 불가능합니다.
          </li>
          <li className={cx('listItem')}>
            오류 해결을 위해
            <span className={cx('mail')}>문의 메일</span>로 연락해 주세요.
          </li>
        </ul>
        <a href={`mailto:${JOBDA_SUPPORT_EMAIL}`} className={cx('link')}>
          문의 메일 : {JOBDA_SUPPORT_EMAIL}
        </a>

        <div className={cx('btnArea')}>
          <a className={cx('btn', 'confirm')} role="button" onClick={onClickBtn}>
            확인
          </a>
        </div>
      </div>
    </Modal>
  );
};

export default UnLinkableModal;
